import React, { useLayoutEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Select,
  Slider,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import OpacityIcon from "@mui/icons-material/Opacity";
import PropTypes from "prop-types";
import Grid2 from "@mui/material/Unstable_Grid2";
import MKBox from "../../components/MKBox";
import { UPDATE_BASEMAP } from "../../store/actions";
import GridCard from "../Cards/GridCard";
import { setOpacity, setVisibleOrNot } from "../../utils/mapProcess";

const GirdCardLayersComputing = ({ children, map, taskStatus }) => {
  const parentRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(null);

  useLayoutEffect(() => {
    if (parentRef.current) {
      const parentHeight = parentRef.current.offsetHeight;
      const titleHeight = parentRef.current ? parentRef.current.children[0].offsetHeight : 50;
      setMaxHeight(parentHeight - titleHeight - 36);
    }
  }, [parentRef]);

  const [BaseMap, setBaseMap] = useState("mapbox");

  const dispatch = useDispatch();

  const handleBaseMap = (e) => {
    setBaseMap(e.target.value);
    dispatch({
      type: UPDATE_BASEMAP,
      value: { name: e.target.value },
    });
  };

  const [xyzLayerState, setxyzLayerState] = useState({
    id: "mosaic_xyz",
    visible: true,
    opacity: 1,
  });

  const xyzExist = () => {
    if (taskStatus) {
      return Object.values(taskStatus).some(
        (g) => g.uri !== undefined && g.uri !== null && g.uri !== ""
      );
    }
    return false;
  };

  const handlexyzLayerVisible = (clicked) => {
    setxyzLayerState({ ...xyzLayerState, visible: clicked.target.checked });
    setVisibleOrNot(map, "mosaic_xyz", clicked.target.checked);
  };

  const handlexyzLayerOpacity = (clicked, value) => {
    setxyzLayerState({ ...xyzLayerState, opacity: value });
    setOpacity(map, "mosaic_xyz", value);
  };

  const handleVectorLayersVisible = (clicked) => {
    if (clicked.target.id === "special" && clicked.target.checked === true) {
      map.getView().fit(
        map
          .getLayers()
          .getArray()
          .filter((t) => t.getClassName() === "special")[0]
          .getSource()
          .getFeatures()[0]
          .getGeometry()
          .getExtent(),
        {
          padding: [100, 100, 100, 100],
        }
      );
    }
    if (clicked.target.id === "status") {
      setVisibleOrNot(map, "grids", clicked.target.checked);
      setVisibleOrNot(map, "tiles", clicked.target.checked);
    } else {
      setVisibleOrNot(map, clicked.target.id, clicked.target.checked);
    }
  };

  return (
    <GridCard title="Layers" ref={parentRef}>
      <MKBox maxHeight={maxHeight} sx={{ height: 1, mx: { lg: 1, xxl: 2, xxxl: 3 } }}>
        <FormControl sx={{ mx: { lg: 1, xxl: 2, xxxl: 3 } }}>
          <FormGroup sx={{ width: "250px" }}>
            <FormLabel focused={false}>BaseMap</FormLabel>
            <Select
              value={BaseMap}
              displayEmpty
              fullWidth
              onChange={handleBaseMap}
              sx={{ m: { xxl: 1, xxxl: 2 }, height: "30px" }}
            >
              <MenuItem value="mapbox">Mapbox</MenuItem>
              <MenuItem value="bing-Aerial-labels">Bing</MenuItem>
              <MenuItem value="openStreetMap">OpenStreetMap</MenuItem>
              <MenuItem value="google">Google</MenuItem>
            </Select>
            <FormLabel focused={false} sx={{ mt: { lg: 0.5, xxl: 1, xxxl: 2 } }}>
              Layers
            </FormLabel>
            {taskStatus ? (
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked
                    color="primary"
                    key="special"
                    id="special"
                    onChange={(e) => handleVectorLayersVisible(e)}
                  />
                }
                label="Region of Interest"
                sx={{ mx: 0.5, m: { xxl: 1, xxxl: 2 } }}
              />
            ) : null}
            {taskStatus ? (
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked
                    color="primary"
                    key="status"
                    id="status"
                    onChange={(e) => handleVectorLayersVisible(e)}
                  />
                }
                label="Tiles / Grids"
                sx={{ mx: 0.5, m: { xxl: 1, xxxl: 2 } }}
              />
            ) : null}
            {xyzExist() ? (
              <Grid2 container xs={12} sx={{ m: { xxl: 1, xxxl: 2 } }}>
                <Grid2 xs={5}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={xyzLayerState.visible}
                        color="primary"
                        id={xyzLayerState.id}
                        onChange={(e) => handlexyzLayerVisible(e)}
                      />
                    }
                    label="Result"
                    sx={{ mx: 0.5 }}
                  />
                </Grid2>

                <Grid2 container item xs={7} sx={{ alignItems: "center" }}>
                  <Grid2 xs={2}>
                    <PanoramaFishEyeIcon style={{ fontSize: 18 }} />
                  </Grid2>
                  <Grid2 xs={7} mx={0.5}>
                    <Slider
                      size="small"
                      width={1}
                      value={xyzLayerState.opacity}
                      onChange={handlexyzLayerOpacity}
                      valueLabelDisplay="auto"
                      min={0}
                      step={0.01}
                      name={xyzLayerState.id}
                      max={1}
                      disabled={!xyzLayerState.visible}
                    />
                  </Grid2>
                  <Grid2 xs={2}>
                    <OpacityIcon style={{ fontSize: 18 }} />
                  </Grid2>
                </Grid2>
              </Grid2>
            ) : null}
          </FormGroup>
        </FormControl>
        {children}
      </MKBox>
    </GridCard>
  );
};

GirdCardLayersComputing.defaultProps = {
  map: null,
  children: null,
  taskStatus: {},
};

GirdCardLayersComputing.propTypes = {
  map: PropTypes.oneOfType([PropTypes.any]),
  children: PropTypes.node,
  taskStatus: PropTypes.oneOfType([PropTypes.object]),
};

export default GirdCardLayersComputing;
